import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import InvoiceFilter from './InvoiceFilter';
import ReviewInvoiceList from './ReviewInvoiceList';
import ReactPaginate from 'react-paginate';

class ReviewInvoices extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            invoice_term: 'weekly',
            search: '',
            offset: 0,
            showUpdateInvoiceModal: false,
            loading: false,
        };
    }

    handleInvoiceApproved = (invoiceId) => {
        this.setState((prevState) => ({
            data: prevState.data.filter((inv) => inv.id !== invoiceId),
        }));
    };

    handleChange = (e) => {
        this.setState({
            invoice_term: e.value,
            offset: 0,
        });
    };

    handleSearchInput = (e) => {
        this.setState({
            search: e.target.value,
            offset: 0,
        });
    };

    handleSearchClick = () => {
        this.loadInvoicesFromServer();
    };

    loadInvoicesFromServer() {
        this.setState({loading: true});
        $.ajax({
            url: this.props.url,
            data: {
                limit: this.props.perPage,
                offset: this.state.offset,
                invoice_term: this.state.invoice_term,
                search: this.state.search,
            },
            dataType: 'json',
            type: 'GET',
            success: (data) => {
                this.setState({
                    data: data.invoices,
                    pageCount: Math.ceil(data.total / this.props.perPage),
                    loading: false
                });
            },

            error: (xhr, status, err) => {
                console.log(this.props.url, status, err.toString());
                toastr.error('Could not load invoices: ' + err.toString());
                this.setState({loading: false});
            },
        });
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.props.perPage);

        this.setState({ offset: offset }, () => {
            this.loadInvoicesFromServer();
        });
    };

    componentDidMount() {
        this.loadInvoicesFromServer();
    }

    render() {
        return (
            <div>
                <div className="row pt-4">
                    <div className="col-12">
                        <div className="cw-bg-grey py-1 d-flex justify-content-between align-items-center">
                            <div>
                                <h6 className="text-white py-2 pl-2">{this.state.invoice_term} Invoices</h6>
                            </div>
                            <div className="pr-2">
                                <InvoiceFilter
                                    options={this.props.filterOptions}
                                    onChange={this.handleChange}
                                    handleSearchInput={this.handleSearchInput}
                                    search={this.state.search}
                                    handleSearchClick={this.handleSearchClick}
                                    value={this.state.invoice_term}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <ReviewInvoiceList
                    data={this.state.data}
                    downloadUrl={this.props.url}
                    invoiceUrl={this.props.invoiceUrl}
                    onInvoiceApproved={this.handleInvoiceApproved}
                />
                <ReactPaginate
                    previousLabel={'previous'}
                    nextLabel={'next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                />
                {this.state.loading ? <div className="processing-card card">Processing...</div> : null}
            </div>
        );
    }
}

if (document.getElementById('review-invoices')) {
    let element = document.getElementById('review-invoices');
    ReactDOM.render(
        <ReviewInvoices
            url={element.dataset.url}
            perPage={element.dataset.per_page}
            filterOptions={JSON.parse(element.dataset.filter_options)}
            invoiceUrl={element.dataset.invoice_url}
        />,
        element
    );
}

export default ReviewInvoices;
